import printerInstance from './instance'

const storePrinter = (data) => {
	return printerInstance.post('/printers', data)
}

export default storePrinter
